import React from 'react';

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as HdrC from './_ccmHdrC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import * as _csLcl from './_csLcl';
import { useNgnz } from './_csNgn';
import * as _gv from './_gv';
import * as _ht from './_ht';
import * as _hm from './_hm';

import * as icm from './icm';
import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  text: 'ホーム',
};

export const R = (pz: {
}) => {

  const _sNgnz = useNgnz();
  const _sPz = _csLcl.usePz();

//_hm.l(`icvHomeM10Rz 32: ${_hm.s(_gUserz.crt._40rz)}`);
  return (
    _cr.c(icvBaseM10Rz.N, {
      boxStlz: a(`fd/csc`),
    }, [

      _cr.c(HdrC.N, {
        key: -10,
        sPz: _sPz,
        abtz: icv.abtz.mainHdrz,
        cz: {
          text: $cz.text
        },
        boxStlz: a(`mb/2`),
      }),

      _cr.c(GridC.N, {
        key: -20,
        abtz: icv.abtz.gridHomez,
        boxStlz: a(`dw/f f/1 fd/cac`),
        lineCs: [
          {
            cellCs: [
              icm.chkPmn(1110) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    abtz: icv.abtz.btnHome1z,
                    lblCz: {
                      text: `配付状況`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icvIz1M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2110) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `販売店`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icvI11M10Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
              icm.chkPmn(2000) ?
              {
                boxClds: [
                  _cr.c(BtnC.N, {
                    abtz: icv.abtz.btnHome2z,
                    lblCz: {
                      text: `その他設定`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sNgnz.setPageName('icvHomeM20Rz');
                        }
                      }            
                    },
                  })
                ]
              }
              : undefined,
            ]
          },

        ]
      })

    ]
    )
  )
};
